import { useEffect, useState } from "react";
import { projectFirestore } from "../../firebase/config";
import { useParams } from "react-router-dom";
import { TaskDetails } from "./TaskDetails";

export const TaskList = () => {
  const { id } = useParams();
  const [tasks, setTasks] = useState("");
  // const [taskId, setTaskId] = useState('')
  // const [isChecked, setIsChecked] = useState(false);
  const [taskId, setTaskId] = useState("");
  // const [taskStatus, setTaskStatus]

  useEffect(() => {
    if (id) {
      projectFirestore
        .collection("projects")
        .doc(id)
        .collection("tasks")
        .onSnapshot(
          (snapshot) =>
            setTasks(
              snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
            )
          // setTasks(snapshot.docs.map((doc) => console.log(doc.id,)))
        );
    }
  }, [id]);
  const handleCheckbox = (e, tId) => {
    const taskStatus = tasks[e].status;

    projectFirestore
      .collection("projects")
      .doc(id)
      .collection("tasks")
      .doc(tId)
      .update({
        status: !taskStatus,
      })
      .then(() => {
        console.log("Document successfully updated!");
      })
      .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
      });

    
  };



  return (
    
<>
<table className="w-full whitespace-nowrap">
      <tbody>
        {tasks < 1 && "No Task yet."}
        {tasks &&
          tasks.map((task, index) => (
            <tr
            key={task.id}
              
              className="border-t-2 border-gray-200 focus:outline-none focus:text-indigo-600 h-16 "
            >
              <td>
                <div className="flex flex-shrink-0 justify-center relative">
                  <input
                    type="checkbox"
                    checked={task.status}
                    onChange={() => handleCheckbox(index, task.id)}
                  />
                </div>
              </td>
              <td className="">
                <div className="flex items-center">
                  <span className={task.status ? "py-1 line-through" : "py-1"}>
                    {task.title}
                  </span>
                </div>
              </td>
              <td className="pl-4">
                <button 
                onClick={<TaskDetails task={task}  />}
                className="focus:ring-2 focus:ring-offset-2  focus:ring-red-300 text-sm leading-none text-gray-600 py-3 px-5 bg-gray-100 rounded hover:bg-gray-200 focus:outline-none">
                  View
                </button>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
</>
    
  );
};
